export default "__VITE_ASSET__8G4MFEA2__"